@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="ProjectStateList"
    [filterable]="true"
    (filterChange)="filterProjectStateList($event)"
    [(ngModel)]="ProjectStates"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [valuePrimitive]="true"
    [data]="ProjectStateList"
    [value]="SelectedProjectStateId"
    (valueChange)="valueChanged($event)">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
@if (uiController === UIControlTyp.InputFieldReadOnly) {
  <input class="form-control" readonly value="{{ getName() }}">
}

